import React, { useEffect, useState } from "react";
import "./Legend.style.scss";
import { useDataLayer } from "../../../Contexts/DataLayer.context.jsx";
import { eventSearch } from "../../../utils/loadFunctions.ts";


const LegendBox = () => {
    const [statusCode, setStatusCode] = useState("");
    const [statusCheck, setStatusCheck] = useState(null);
    const [statusWorked, setStatusWorked] = useState('-');
    const [countryCheck, setCountryCheck] = useState(null);
    const [countryWorked, setCountryWorked] = useState('-');
    const [countryCode, setCountryCode] = useState("");
    const [naCheck, setnaCheck] = useState(null);
    const [naWorked, setnaWorked] = useState('-');
    const [naCode, setnaCode] = useState("");
    const [intCheck, setintCheck] = useState(null);
    const [intWorked, setintWorked] = useState('-');
    const [intCode, setintCode] = useState("");
    const [eventCheck, setEventCheck] = useState(null);
    const [eventWorked, setEventWorked] = useState('-');
    const [eventCode, setEventCode] = useState("");
    const [reverse, setReverse] = useState(false);
    const [dropOpen, setDropOpen] = useState(null);
    const [selectedCountry, setSelectCountry] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);

    const { countryArray, schoolArray, eventArray } = useDataLayer();

    useEffect(() => {
        console.log(schoolArray);
        setSelectCountry('-');
        setDropOpen(null);
    }, [reverse])



    // Handles user input and triggers lookup when the required length is met
    const handleInputChange = async (e, whatBox) => {
        const code = e.target.value.toUpperCase();
        setStatusWorked('-');
        setCountryWorked('-');
        setnaWorked('-');
        setintWorked('-');
        setEventWorked('-');
        setCountryCheck([]);
        setintCheck([]);
        setnaCheck([]);
        setStatusCheck([]);
        setEventCheck(null);
        setIsExpanded(false);
        switch (whatBox) {
            case 'Status':
                setStatusCode(code);
                // setStatusCheck(null);
                setCountryCode("");
                setintCode("");
                setnaCode("");
                setEventCode("");
                if (code.length === 2) {
                    findStatus(code);
                }
                break;

            case 'Country':
                setCountryCode(code);
                setStatusCode("");
                setintCode("");
                setnaCode("");
                setEventCode("");
                if (code.length === 3) {
                    findCountry(code);
                }
                break;

            case 'School':
                setnaCode(code);
                setCountryCode("");
                setintCode("");
                setStatusCode("");
                setEventCode("");
                if (code.length === 4) {
                    findSchool(code);
                }
                break;

            case 'InternationalSchool':
                setintCode(code);
                setStatusCode("");
                setCountryCode("");
                setnaCode("");
                setEventCode("");
                if (code.length === 5) {
                    findInternationalSchool(code);
                }
                break;

            case 'Event':
                setEventCode(code);
                setStatusCode("");
                setCountryCode("");
                setnaCode("");
                setintCode("");
                if (code.length >= 3) {
                    findEvent(code);
                }
                break;

            default:
                console.log('Unknown input');
                break;
        }
    };

    // Fetch status information
    const findStatus = async (code) => {
        try {
            const response = await fetch("https://www.fbxchange.com/ReactPHP/legend.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ statusCode: code, script: "getStatus" }),
            });

            const data = await response.json();
            setIsExpanded(true);
            if (data && data.length > 0) {
                setStatusCheck(data);
                setStatusWorked(data[0].worked === "Yes" ? "Yes" : "No");
            } else {
                setStatusWorked("No");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setStatusWorked("No");
        }
    };

    // Fetch country information
    const findCountry = async (code) => {
        try {
            const response = await fetch("https://www.fbxchange.com/ReactPHP/legend.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ statusCode: code, script: "getCountry" }),
            });

            const data = await response.json();
            setIsExpanded(true);
            if (data && data.length > 0) {
                setCountryCheck(data);
                setCountryWorked(data[0].worked === "Yes" ? "Yes" : "No");
            } else {
                setCountryCheck(null); // Ensure state is reset if no data
                setCountryWorked("No");
            }
        } catch (error) {
            console.error("Error fetching country data:", error);
            setCountryWorked("No");
        }
    };


    // Fetch school information
    const findSchool = async (code) => {
        try {
            const response = await fetch("https://www.fbxchange.com/ReactPHP/legend.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ statusCode: code, script: "getSchool" }),
            });

            const data = await response.json();
            console.log(data);
            setIsExpanded(true);
            if (data && data.length > 0) {
                setnaCheck(data[0]);
                setnaWorked(data[0].worked === "Yes" ? "Yes" : "No");
            } else {
                setnaCheck(null); // Ensure state is reset if no data
                setnaWorked("No");
            }
        } catch (error) {
            console.error("Error fetching country data:", error);
            setnaWorked("No");
        }
    };

    // Fetch international school information
    const findInternationalSchool = async (code) => {
        try {
            const response = await fetch("https://www.fbxchange.com/ReactPHP/legend.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ statusCode: code, script: "getIntSchool" }),
            });

            const data = await response.json();
            console.log(data);
            setIsExpanded(true);
            if (data && data.length > 0) {
                setintCheck(data[0]);
                setintWorked(data[0].worked === "Yes" ? "Yes" : "No");
            } else {
                setintCheck(null); // Ensure state is reset if no data
                setintWorked("No");
            }
        } catch (error) {
            setintWorked("No");
        }
    };

    const findEvent = (code) => {
        const events = Array.isArray(eventArray) && eventArray.length > 0 ? eventArray : eventSearch;
        const cleanCode = String(code || "").trim().toUpperCase();
        const foundEvent = events.find((event) => (
            String(event?.Team || event?.team || "").trim().toUpperCase() === cleanCode
        ));

        setIsExpanded(true);
        if (foundEvent) {
            setEventCheck(foundEvent);
            setEventWorked("Yes");
        } else {
            setEventCheck(null);
            setEventWorked("No");
        }
    };

    const setView = (inval) => {
        setIsExpanded(false);
        setReverse(inval);
    }

    const displayBox = (field, value) => {
        setDropOpen(field);
        setSelectCountry(value);
    }

    const copyToClipboard = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (err) {
            alert('Failed to copy!');
        }
    };

    return (
        <div className={`legendBox ${isExpanded ? 'expanded' : ''}`}>
            {/* Search Mode Selection */}
            <div className="col-48 gap-2 d-flex justify-content-between mt-2" style={{ lineHeight: "35px" }}>
                <div className={`col-24 btn ${reverse ? 'btn-outline-navy' : 'btn-navy'}`} onClick={() => setView(false)}>Search</div>
                <div className={`col-24 btn ${reverse ? 'btn-navy' : 'btn-outline-navy'}`} onClick={() => setView(true)}>Reverse Search</div>
            </div>

            {!reverse ? (
                <div className="d-flex gap-2 mt-2">
                    <div className="left-side">
                        <div id="status">
                            <div className="text-start fs-7 text-uppercase fw-bold mb-1">Player Status Search</div>
                            <div className="d-flex gap-2">
                                <div className="text-start fs-8 col-22 p-2">Enter 2 Letter Code</div>
                                <div className="col-24">
                                    <input
                                        type="text"
                                        className="form-control fs-8 outline-secondary text-uppercase"
                                        placeholder="Status Code (2 Letters)"
                                        value={statusCode}
                                        onChange={(e) => handleInputChange(e, 'Status')}
                                        maxLength={2}
                                    />
                                </div>
                            </div>
                        </div>
                        <div id="country" className="mt-3">
                            <div className="text-start fs-7 text-uppercase fw-bold mb-1">Country Code Search</div>
                            <div className="d-flex gap-2">
                                <div className="text-start fs-8 col-22 p-2">Enter 3 Letter Code</div>
                                <div className="col-24">
                                    <input
                                        type="text"
                                        className="form-control fs-8 outline-secondary text-uppercase"
                                        placeholder="Country Code (3 Letters)"
                                        value={countryCode}
                                        onChange={(e) => handleInputChange(e, 'Country')}
                                        maxLength={3}
                                    />
                                </div>
                            </div>
                        </div>
                        <div id="usaschool" className="mt-3">
                            <div className="text-start fs-7 text-uppercase mb-1 fw-bold">North American School Search</div>
                            <div className="d-flex gap-2">
                                <div className="text-start fs-8 col-22 p-2">Enter 4 Letter Code</div>
                                <div className="col-24">
                                    <input
                                        type="text"
                                        className="form-control fs-8 outline-secondary text-uppercase"
                                        placeholder="School Code (4 Letters)"
                                        value={naCode} // Assuming `schoolCode` is the state for this input
                                        onChange={(e) => handleInputChange(e, 'School')}
                                        maxLength={4}
                                    />
                                </div>
                            </div>
                        </div>
                        <div id="intschool" className="mt-3">
                            <div className="text-start fs-7 text-uppercase mb-1 fw-bold">International School Search</div>
                            <div className="d-flex gap-2">
                                <div className="text-start fs-8 col-22 p-2">Enter 5 Letter Code</div>
                                <div className="col-24">
                                    <input
                                        type="text"
                                        className="form-control fs-8 outline-secondary text-uppercase"
                                        placeholder="School Code (5 Letters)"
                                        value={intCode}
                                        onChange={(e) => handleInputChange(e, 'InternationalSchool')}
                                        maxLength={5}
                                    />
                                </div>
                            </div>
                        </div>
                        <div id="eventsearch" className="mt-3">
                            <div className="text-start fs-7 text-uppercase mb-1 fw-bold">Event Search</div>
                            <div className="d-flex gap-2">
                                <div className="text-start fs-8 col-22 p-2">Enter Event Code</div>
                                <div className="col-24">
                                    <input
                                        type="text"
                                        className="form-control fs-8 outline-secondary text-uppercase"
                                        placeholder="Event Code"
                                        value={eventCode}
                                        onChange={(e) => handleInputChange(e, 'Event')}
                                        maxLength={8}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right-side">
                        <div id="statusOut">
                            {statusWorked !== '-' && (
                                <div className={`w-100 ${statusWorked === "Yes" ? "alert-success" : "alert-danger"} p-3`}>
                                    <div className="col-48 text-center fw-bold">Status Information</div>
                                    <div className="d-flex bg-navy text-lemon" style={{ lineHeight: "30px" }}>
                                        <div className="col-12 text-center">Code</div>
                                        <div className="col-12 text-center">League</div>
                                        <div className="col-24 text-center">Translation</div>
                                    </div>
                                    {statusCheck && statusCheck.length > 0 ? (
                                        statusCheck.map((status, index) => (
                                            <div key={index} className="d-flex mb-1 p-1 text-uppercase">
                                                <div className="col-12 fs-6 text-center">{status.status_id}</div>
                                                <div className="col-12 fs-6 text-center">{status.league}</div>
                                                <div className="col-24 fs-6 text-center">{status.status}</div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="d-flex alert-danger" style={{ lineHeight: "30px" }}>
                                            <div className="col-12 text-center">{statusCode}</div>
                                            <div className="col-12 text-center">-</div>
                                            <div className="col-24 text-center">Not Found</div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div id="countryOut">
                            {countryWorked !== '-' && (
                                <div className={`p-3 ${countryWorked === "Yes" ? "alert-success" : "alert-danger"}`}>
                                    <div className="col-48 text-center fw-bold">Status Information</div>
                                    <div className="d-flex bg-navy text-lemon" style={{ lineHeight: "30px" }}>
                                        <div className="col-8 text-center">Code</div>
                                        <div className="col-22 text-center">Country</div>
                                        <div className="col-8 text-center">Code 2</div>
                                        <div className="col-8 text-center">Code UN</div>
                                    </div>
                                    {countryCheck && countryCheck.length > 0 ? (
                                        countryCheck.map((status, index) => (
                                            <div key={index} className="d-flex mb-1 p-1 text-uppercase">
                                                <div className="col-8 text-center">{status.CODE_3}</div>
                                                <div className="col-22 text-center">{status.COUNTRY}</div>
                                                <div className="col-8 text-center">{status.CODE_2}</div>
                                                <div className="col-8 text-center">{status.UN_CODE}</div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="d-flex alert-danger" style={{ lineHeight: "30px" }}>
                                            <div className="col-12 text-center">{statusCode}</div>
                                            <div className="col-12 text-center">-</div>
                                            <div className="col-24 text-center">Not Found</div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div id="naOut">
                            {naWorked !== '-' && (
                                <div className={naWorked === "Yes" ? "alert-success p-3" : "alert-danger p-3"}>
                                    <div className="col-48 text-center fw-bold">School Information</div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">School Code :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.SCHOOL_code || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">School :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.school_short_name || "N/A"}</div>
                                    </div>
                                    <div className="col-48 gap-2 d-flex mt-2">
                                        <div className="col-20 fs-6 text-end">Nickname :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.NICKNAME || "N/A"}</div>
                                    </div>
                                    <div className="col-48 gap-2 d-flex mt-2">
                                        <div className="col-20 fs-6 text-end">State :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.STATE || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">City :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.CITY || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Conference :</div>

                                        <div className="col-24 fs-6 text-start">{naCheck?.CONFERENCE || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Division :</div>
                                        <div className="col-14 fs-6 text-start">{naCheck?.DivisionT || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Website :</div>
                                        <div className="col-24 fs-6 text-start">
                                            {naCheck?.FBwebsite ? (
                                                <a href={naCheck.FBwebsite} target="_blank" rel="noopener noreferrer">
                                                    Web Link
                                                </a>
                                            ) : "N/A"}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div id="intOut">
                            {intWorked !== '-' && (
                                <div className={intWorked === "Yes" ? "alert-success p-3" : "alert-danger p-3"}>
                                    <div className="col-48 text-center fw-bold">School Information</div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">School Code :</div>
                                        <div className="col-24 fs-6 text-start">{intCheck?.SCHOOL_code || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">School :</div>
                                        <div className="col-24 fs-6 text-start">{intCheck?.school_short_name || "N/A"}</div>
                                    </div>
                                    <div className="col-48 gap-2 d-flex mt-2">
                                        <div className="col-20 fs-6 text-end">Nickname :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.NICKNAME || "N/A"}</div>
                                    </div>
                                    <div className="col-48 gap-2 d-flex mt-2">
                                        <div className="col-20 fs-6 text-end">State :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.STATE || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">City :</div>
                                        <div className="col-24 fs-6 text-start">{naCheck?.CITY || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Conference :</div>

                                        <div className="col-24 fs-6 text-start">{naCheck?.CONFERENCE || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Division :</div>
                                        <div className="col-14 fs-6 text-start">{naCheck?.DivisionT || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Website :</div>
                                        <div className="col-24 fs-6 text-start">
                                            {naCheck?.FBwebsite ? (
                                                <a href={naCheck.FBwebsite} target="_blank" rel="noopener noreferrer">
                                                    Web Link
                                                </a>
                                            ) : "N/A"}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div id="eventOut">
                            {eventWorked !== '-' && (
                                <div className={eventWorked === "Yes" ? "alert-success p-3" : "alert-danger p-3"}>
                                    <div className="col-48 text-center fw-bold">Event Information</div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Event Code :</div>
                                        <div className="col-24 fs-6 text-start">{eventCheck?.Team || eventCode || "N/A"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Event :</div>
                                        <div className="col-24 fs-6 text-start">{eventCheck?.Team_Name || "Not Found"}</div>
                                    </div>
                                    <div className="col-48 d-flex gap-2 mt-2">
                                        <div className="col-20 fs-6 text-end">Affiliation :</div>
                                        <div className="col-24 fs-6 text-start">{eventCheck?.Affiliation || "N/A"}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div>
                        <div className="col-46 offset-1 p-1 mt-3">
                            <div className="text-start fs-7 text-uppercase fw-bold mb-1">Country Code</div>
                            <div className="col-48 d-flex gap-3">
                                <div className="text-start fs-8 col-22 p-2">Find Country in List</div>
                                <div className="col-25">
                                    <select className="form-select fs-8 outline-secondary text-uppercase"
                                        value={selectedCountry}
                                        onChange={(e) => displayBox('Country', e.target.value)}>
                                        <option value="-">Select an Country</option>
                                        {countryArray.map((country, index) => (
                                            <option key={index} className="optionBox" value={country.CODE_3}>{country.COUNTRY}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {dropOpen === 'Country' && selectedCountry !== "-" && (
                            <div className="col-46 offset-1 alert alert-success mt-1">
                                <div className="fw-bold col-48 fs-5 text-center">
                                    The Code for this Country is {selectedCountry}
                                </div>
                                <div className="col-48">
                                    <button
                                        className="col-24 offset-12 btn btn-primary fs-7 mt-3"
                                        onClick={() => copyToClipboard(selectedCountry)}
                                    >
                                        Copy This Code to Clipboard
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                    <div>
                        <div className="col-46 offset-1 p-1 mt-3">
                            <div className="text-start fs-7 text-uppercase fw-bold mb-1">School Code</div>
                            <div className="col-48 d-flex gap-3">
                                <div className="text-start fs-8 col-22 p-2">Find School in List</div>
                                <div className="col-25">
                                    <select className="form-select fs-8 outline-secondary text-uppercase"
                                        value={schoolArray}
                                        onChange={(e) => displayBox('School', e.target.value)}>
                                        <option value="-">Select a School</option>
                                        {schoolArray.map((school, index) => (
                                            <option key={index} className="optionBox" value={school.schoolcode}>{school.school_short_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {dropOpen === 'School' && selectedCountry !== "-" && (
                            <div className="col-46 offset-1 alert alert-success mt-1">
                                <div className="fw-bold col-48 fs-5 text-center">
                                    The Code for this School is {selectedCountry}
                                </div>
                                <div className="col-48">
                                    <button
                                        className="col-24 offset-12 btn btn-primary fs-7 mt-3"
                                        onClick={() => copyToClipboard(selectedCountry)}
                                    >
                                        Copy This Code to Clipboard
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
};

export default LegendBox;
